import React, { Component } from 'react';
import { Navigate } from 'react-router-dom';
import { Api, EventBus } from 'src/helpers/new';
import withRouterAndRedux from 'src/hoc/withRouterAndRedux';
class VerifyAccount extends Component {
    state = {
        redirect: false,
    };
    async componentDidMount() {
        const query = new URLSearchParams(this.props.location.search),
            verifyToken = query.get('verifyToken'),
            { success, message } = await Api.call('GET', `/users/verify/${verifyToken}/`);

        this.setState(
            {
                redirect: true,
            },
            () => {
                const { loggedIn } = this.props;

                this.props.setLoggedIn({
                    token: loggedIn.token,
                    user: {
                        ...loggedIn.user,
                        verified: new Date().toISOString(),
                    },
                });
                if (success) {
                    EventBus.dispatch('toast', {
                        type: 'success',
                        message: message,
                    });
                }
            },
        );
    }
    render() {
        return <div>{this.state.redirect && <Navigate to='/' />}</div>;
    }
}

export default withRouterAndRedux(VerifyAccount, (state) => ({ loggedIn: state.loggedIn }), {
    setLoggedIn: (payload) => ({
        type: 'SET_LOGGED_IN',
        payload,
    }),
});
